import React from 'react';
import { Instructions } from '..';


const ContentDefault = () => (
  <React.Fragment>
    <div className="contentDefault-wrapper">
      <h1 className="contentDefault-welcomeMessage">Welcome to CADESS</h1>
      <div className="contentDefault-text-wrapper">
        <Instructions />
      </div>
    </div>
  </React.Fragment>
);

export default ContentDefault;
